export default function processData(data) {
  let transactions = {};
  let voids = { count: 0, amount: 0 };
  let orders = { handheldCount: 0, posCount: 0, appCount: 0 };
  let totalTurnover = {};
  let totalVats = {};
  let payments = {
    "Tip (Fooi)": { amount: 0, count: 0, isTurnover: 0 },
    "TransactionCosts (Transactiekosten)": { amount: 0, count: 0, isTurnover: 0 },
  };
  let articles = {};
  let menus = {};
  let numberOfPaidBills = 0;

  data.forEach((spReceipt) => {
    if (spReceipt.reporting != null) {
      if (spReceipt.reporting.articles != null) {
        //// Articles
        Object.keys(spReceipt.reporting.articles).forEach((plu) => {
          Object.keys(spReceipt.reporting.articles[plu]["names"]).forEach((name) => {
            Object.keys(spReceipt.reporting.articles[plu]["names"][name]).forEach((price) => {
              let article = spReceipt.reporting.articles[plu]["names"][name][price];

              let variable = spReceipt.reporting.articles[plu]["is_menu"] ? menus : articles;
              if (variable[plu] == null) {
                variable[plu] = {};
              }
              if (variable[plu][name] == null) {
                variable[plu][name] = {};
              }
              if (variable[plu][name][price] == null) {
                variable[plu][name][price] = article;
              } else {
                Object.keys(article).forEach((amount) => {
                  if (amount !== "articlegroup_name") {
                    variable[plu][name][price][amount] += article[amount];
                  }
                });
              }
            });
          });
        });

        if (
          Object.keys(spReceipt.reporting.articles).some((plu) => {
            return Object.keys(spReceipt.reporting.articles[plu]["names"]).some((name) => {
              return Object.keys(spReceipt.reporting.articles[plu]["names"][name]).some((price) => {
                return spReceipt.reporting.articles[plu]["names"][name][price]["amount_paid"] > 0;
              });
            });
          })
        ) {
          numberOfPaidBills += 1;
        }
      }

      orders.appCount += spReceipt.reporting.total_order_count.APP;
      orders.handheldCount += spReceipt.reporting.total_order_count.HANDHELD;
      orders.posCount += spReceipt.reporting.total_order_count.POS;

      let turnoverPerVatIncVat = {};
      let tip = spReceipt.tip_amount;

      Object.keys(spReceipt.reporting.total_amount_per_transaction).forEach((transactionType) => {
        if (transactionType === "OK") {
          if (transactions[transactionType] === undefined) {
            transactions[transactionType] = { count: 0, amount: 0 };
          }
          transactions[transactionType].count += 1;
          let totalOfTransaction = 0;
          Object.keys(spReceipt.reporting.total_amount_per_transaction[transactionType]["vats"]).forEach((vat) => {
            transactions[transactionType].amount +=
              spReceipt.reporting.total_amount_per_transaction[transactionType]["vats"][vat].amount;
            totalOfTransaction += spReceipt.reporting.total_amount_per_transaction[transactionType]["vats"][vat].amount;
            if (turnoverPerVatIncVat[vat] === undefined) {
              turnoverPerVatIncVat[vat] = 0;
            }
            turnoverPerVatIncVat[vat] +=
              spReceipt.reporting.total_amount_per_transaction[transactionType]["vats"][vat].amount;
          });

          if (
            Object.keys(spReceipt.reporting.total_amount_per_transaction[transactionType]["amount_per_turnover_group"])
              .length === 0
          ) {
            if (payments["Onbekend"] === undefined) {
              payments["Onbekend"] = {
                amount: 0,
                count: 0,
                isTurnover: 1,
              }; // Waardebon = {isTurnover: 0, isVatDue: 1}, Korting = {isTurnover: 0, isVatDue:0}
            }
            payments["Onbekend"].amount += totalOfTransaction;
            payments["Onbekend"].count += 1;
          }
          Object.keys(
            spReceipt.reporting.total_amount_per_transaction[transactionType]["amount_per_turnover_group"]
          ).forEach((paymentMethod) => {
            if (payments[paymentMethod] === undefined) {
              let isTurnover = 1;
              if (
                spReceipt.reporting.total_amount_per_transaction[transactionType]["amount_per_turnover_group"][
                  paymentMethod
                ]["is_turnover"] !== undefined
              ) {
                isTurnover = spReceipt.reporting.total_amount_per_transaction[transactionType][
                  "amount_per_turnover_group"
                ][paymentMethod]["is_turnover"]
                  ? 1
                  : 0;
              }
              payments[paymentMethod] = {
                amount: 0,
                count: 0,
                isTurnover: isTurnover,
              }; // Waardebon = {isTurnover: 0, isVatDue: 1}, Korting = {isTurnover: 0, isVatDue:0}
            }
            if (payments[paymentMethod].isTurnover === 0) {
              let totalAmount = 0;
              Object.keys(turnoverPerVatIncVat).filter(vatKey => vatKey != 0).forEach((vatKey) => {
                totalAmount += turnoverPerVatIncVat[vatKey];
              });
              if (totalAmount !== 0) {
                Object.keys(turnoverPerVatIncVat).filter((vatKey) => vatKey != 0).forEach((vatKey) => {
                  turnoverPerVatIncVat[vatKey] -=
                    (spReceipt.reporting.total_amount_per_transaction[transactionType]["amount_per_turnover_group"][
                      paymentMethod
                    ].amount *
                      turnoverPerVatIncVat[vatKey]) /
                    totalAmount;
                });
              }
            }

            payments[paymentMethod].amount +=
              spReceipt.reporting.total_amount_per_transaction[transactionType]["amount_per_turnover_group"][
                paymentMethod
              ].amount;
            payments[paymentMethod].count += 1;
          });
        } else if (transactionType === "VOID") {
          voids.count += 1;

          Object.keys(spReceipt.reporting.total_amount_per_transaction[transactionType]["vats"]).forEach((vatKey) => {
            voids.amount += spReceipt.reporting.total_amount_per_transaction[transactionType]["vats"][vatKey].amount;
          });
        }
      });

      if (tip > 0) {
        payments["Tip (Fooi)"].amount += tip;
        payments["Tip (Fooi)"].count += 1;
      }

      if (spReceipt.transaction_costs > 0) {
        payments["TransactionCosts (Transactiekosten)"].amount += spReceipt.transaction_costs;
        payments["TransactionCosts (Transactiekosten)"].count += 1;

        if (turnoverPerVatIncVat[0.21] === undefined) {
          turnoverPerVatIncVat[0.21] = 0;
        }
        turnoverPerVatIncVat[0.21] += spReceipt.transaction_costs;
      }

      Object.keys(turnoverPerVatIncVat).forEach((vatKey) => {
        if (totalVats[vatKey] === undefined) {
          totalVats[vatKey] = 0;
        }
        totalVats[vatKey] += (turnoverPerVatIncVat[vatKey] / (1 + Number.parseFloat(vatKey))) * vatKey;

        if (totalTurnover[vatKey] === undefined) {
          totalTurnover[vatKey] = 0;
        }
        totalTurnover[vatKey] += turnoverPerVatIncVat[vatKey] / (1 + Number.parseFloat(vatKey));
      });
    }
  });

  return {
    transactions: transactions,
    orders: orders,
    voids: voids,
    totalVats: totalVats,
    totalTurnover: totalTurnover,
    payments: payments,
    numberOfPaidBills: numberOfPaidBills,
    articles: articles,
    menus: menus,
  };
}
